/* eslint-disable no-extend-native */

if (typeof global.gettext === 'undefined') {
    /**
     * @param {string} msgid
     * @returns {string}
     */
    global.gettext = msgid => msgid;
}

export const gettext = global.gettext;
export const _ = gettext;

if (typeof global.pgettext === 'undefined') {
    /**
     * @param {string} msgctxt
     * @param {string} msgid
     * @returns {string}
     */
    global.pgettext = (msgctxt, msgid) => global.gettext(msgid);
}

export const pgettext = global.pgettext;

if (typeof global.ngettext === 'undefined') {
    /**
     * @param {string} singular
     * @param {string} plural
     * @param {number} count
     * @returns {string}
     */
    global.ngettext = (singular, plural, count) => (count === 1 ? singular : plural);
}

export const ngettext = global.ngettext;

if (typeof global.interpolate === 'undefined') {
    /**
     * @param {string} msgid
     * @param {object|array} context
     * @param {boolean} named
     * @returns {string}
     */
    global.interpolate = (msgid, context, named) => msgid;
}

/**
 * @param {object} context
 * @returns {string}
 */
String.prototype.interpolate = function interpolate(context) {
    return global.interpolate(this, context, true);
};

export default gettext;



// WEBPACK FOOTER //
// ./scripts/utils/i18n.js